module.exports = __webpack_public_path__ + "img/banana.d31a7037.png";